
import React from "react";
import { PremiumBotForm } from "@/components/admin/premium-bots/PremiumBotForm";

const PremiumBotAddPage = () => {
  return (
    <div className="container mx-auto py-6 space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Add New Premium Bot</h1>
      </div>
      
      <PremiumBotForm />
    </div>
  );
};

export default PremiumBotAddPage;
